import React, { Fragment } from "react";
import {
  Facebook as FacebookIcon,
  Twitter as TwitterIcon,
  YouTube as YouTubeIcon,
  Instagram as InstagramIcon,
  LocationOn as LocationOnIcon,
} from "@mui/icons-material";
import { Link } from "gatsby";

const MainFooter = ({
  address = "40 NE Interstate 410 Loop #565, San Antonio, TX 78216",
  // phoneNumber = "800-816-1003",
}) => {
  const links = [
    {
      name: "Home",
      path: "/",
    },
    {
      name: "Apply",
      path: "/apply/",
    },
    {
      name: "Blogs",
      path: "/blogs/",
    },
    {
      name: "Service Areas",
      path: "/service-areas/",
    },
    {
      name: "Privacy Policy / Terms of service",
      path: "/privacy-policy/",
    },
  ];

  return (
    <Fragment>
      <footer className="bg-green-800 py-16">
        <div className="container">
          <div className="grid grid-cols-1 lg:grid-cols-[40%_30%_30%] gap-6">
            <div>
              <img src="/images/logo.png" width={160} alt="Logo" />
              <div className="flex items-center mt-6">
                <a
                  className="bg-white me-4 w-[32px] h-[32px] rounded-full flex justify-center items-center"
                  href="https://www.facebook.com/affordabledebtconsolidation"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Facebook Btn"
                >
                  <FacebookIcon className="text-custom-primary !text-base !font-normal" />
                </a>
                <a
                  className="bg-white me-4 w-[32px] h-[32px] rounded-full flex justify-center items-center"
                  href="https://twitter.com/adconsolidation"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Facebook Btn"
                >
                  <TwitterIcon className="text-custom-primary !text-base !font-normal" />
                </a>
                <a
                  className="bg-white me-4 w-[32px] h-[32px] rounded-full flex justify-center items-center"
                  href="https://www.youtube.com/channel/UC2BWcLZBRoW782zjQNxAcRA"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Youtube Btn"
                >
                  <YouTubeIcon className="text-custom-primary !text-base !font-normal" />
                </a>
                <a
                  className="bg-white w-[32px] h-[32px] rounded-full flex justify-center items-center"
                  href="https://www.instagram.com/affordabledebtconsolidation"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Instagram Btn"
                >
                  <InstagramIcon className="text-custom-primary !text-base !font-normal" />
                </a>
              </div>
              <p className="text-xl font-normal text-white mb-4 mt-8">
                Consultations with a Texas Debt Specialist are free of charge
                and have no obligation.
              </p>
            </div>
            <div>
              <p className="text-2xl font-normal text-white mb-6">
                Quick Links
              </p>
              <ul>
                {links.map((link, index) => (
                  <li className="mb-6" key={index}>
                    <Link
                      className="text-lg font-light text-white capitalize transition-all duration-200 opacity-100 hover:opacity-60"
                      to={link.path}
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            {/* <div>
              <p className="text-2xl font-normal text-white mb-6">
                Useful Links
              </p>
              <ul>
                {links.map((link, index) => (
                  <li className="mb-6" key={index}>
                    <Link
                      className="text-lg font-light text-white capitalize transition-all duration-200 opacity-100 hover:opacity-60"
                      to={link.path}
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-2xl font-normal text-white mb-6">Support</p>
              <ul>
                {links.slice(0, 3).map((link, index) => (
                  <li className="mb-6" key={index}>
                    <Link
                      className="text-lg font-light text-white capitalize transition-all duration-200 opacity-100 hover:opacity-60"
                      to={link.path}
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div> */}
            <div>
              <p className="text-xl font-bold text-white mb-2">Corporate Office</p>
              <p className="text-md font-medium text-white flex items-center">
                <LocationOnIcon className="me-2" /> 40 NE Interstate 410 Loop
                #565, San Antonio, TX 78216
              </p>

              {/* <p className="text-xl font-bold text-white mb-2 mt-12">
                Corporate Office
              </p>

              <p className="text-md font-medium text-white flex items-center text-balance w-auto">
                <LocationOnIcon className="me-2" /> {address}
              </p> */}

              <p className="text-md font-normal text-white w-[22rem] mt-8 ms-2 text-balance">
                Please Call For Additional Texas Branch Locations
              </p>
            </div>
          </div>
          <div className="mt-20 text-white font-normal">
            <h3 className="text-xl mb-3">
              Copyright © {new Date().getFullYear()} Affordable Debt
              Consolidation Texas. All rights reserved
            </h3>
            <p className="text-xs text-justify">
              *Affordable debt consolidation’s performance (settlement) fees are
              15% versus up to 25% charged by many out-of-state competitors.
              Affordable Debt Consolidation is not a lender but offers a
              platform to receive offers from participating lenders. Debt
              enrolled in credit counseling generally receives an interest rate
              between 6% and 11%. Debt negotiation clients who make their
              scheduled monthly program payments generally experience an
              approximate 45% reduction of their enrolled balance before fees or
              approximately a 30% reduction after payment of settlement fees of
              15% over an estimated 24-48 month period. Settlement fees and
              estimates do not include a $9.95 a month special purpose account
              fee or any optional and separate services such as those provided
              by Texas attorneys. Individual results vary based on the ability
              to fund the program and the creditors enrolled. Statements made
              are examples of past performance and are not intended to guarantee
              that your balances will be reduced by a specific amount or that
              you will resolve debt within a specific time period. We do not
              charge settlement fees until a debt balance is reduced and at
              least one payment is made to the creditor. We do not assume
              consumer debt, make monthly payments, or provide tax or legal
              advice. We are not a credit repair firm. Please contact a tax
              professional to discuss any possible tax consequences of paying
              less than the full balance. Programs are available in Texas.
              Affordable Debt Consolidation is a DBA of Debt Redemption Inc.
              registered with the Texas Secretary of State.
            </p>
          </div>
        </div>
      </footer>
    </Fragment>
  );
};

export default MainFooter;
